import {Component} from "@angular/core";

/**
 * Placeholder space for the Intercom button
 */
@Component({
    selector: "wbo-messaging-footer-button",
    styleUrls: ["./messaging-footer-button.component.scss"],
    templateUrl: "./messaging-footer-button.component.html"
})
export class MessagingFooterButtonComponent {

}
